import { Report } from '../models/Report'
import dayjs from 'dayjs'

export class ApiReport {
  static get Builder () {
    class Builder {
      constructor (apiReport) {
        this.id = apiReport.id
        this.title = apiReport.attributes.title
        this.target = apiReport.attributes.target
        this.supplier = apiReport.attributes.supplier
        this.service = apiReport.attributes.service
        this.product = apiReport.attributes.product
        this.portal = apiReport.attributes.portal
        this.openRateCost = apiReport.attributes.openRateCost
        this.openRate = apiReport.attributes.openRate
        this.open = apiReport.attributes.open
        this.materials = apiReport.attributes.materials
        this.display = apiReport.attributes.display
        this.date = dayjs.unix(apiReport.attributes.date)
        this.ctrCost = apiReport.attributes.ctrCost
        this.ctr = apiReport.attributes.ctr
        this.creation = apiReport.attributes.creation
        this.cost1K = apiReport.attributes.cost1K
        this.cost = apiReport.attributes.cost
        this.click = apiReport.attributes.click
        this.visual = apiReport.attributes.visual
      }
      build () {
        return new Report(this)
      }
    }
    return Builder
  }
}
